/**
 * Safe, pre-validated regex patterns for document validation and normalization.
 * These patterns are whitelisted to prevent ReDoS attacks.
 */

export const DOCUMENT_PATTERNS = {
  '[^0-9]': /[^0-9]/g,
  '\\s': /\s/g,
  '\\d': /\d/g,
  '[aeiou]': /[aeiou]/g,
  '^[A-Z0-9]+$': /[^A-Z0-9]/g,
  '^[0-9]{8}$': /[^0-9]/g,
  '^[A-Z]{3}-[0-9]{3}$': /[^A-Z0-9-]/g, // Remove chars not allowed in invoice format
  '^[A-Z0-9-]+$': /[^A-Z0-9-]/g,
  '^[0-9]+$': /[^0-9]/g,
  '^[A-Z]+$': /[^A-Z]/g,
  '(^0+)|[^0-9]+': /(^0+)|[^0-9]+/g,
  '[^a-zA-Z0-9]*$': /[^a-zA-Z0-9]*$/g,
  '^[1-9][0-9]{3,9}$': /[^0-9]/g,
  '^([a-zA-Z]{1,5})?[1-9][0-9]{3,7}$': /[^a-zA-Z0-9]/g,
  '^[1-9][0-9]{4,11}$': /[^0-9]/g,
  '^[1-9]\\d{6,9}$': /[^0-9]/g,
};

export const FALLBACK_PATTERN = /\s/g;
